import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { sortQuestionsByTitle } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

export const useDefaultQuestionsQuery = () => {
  const canListQuestions = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Questions);

  return useTypedQuery({
    queryKey: ChecklistsDashboardQueryKeys.defaultQuestions,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, {}, baseUrl)).data.questions ?? [],
    select: sortQuestionsByTitle,
    enabled: canListQuestions
  });
};
